import { Injectable } from '@angular/core';
import { HttpInterceptorProvider } from '../http-interceptor/http-interceptor';
import { Observable } from 'rxjs/Observable';
import { UserProvider } from '../user/user';
import { baseUrlFunc } from '../../app/app.module';

/*
  Generated class for the ReportsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ReportsProvider {

  apiBase = baseUrlFunc() + "emailvisita/v1/rout"
  apiBaseDuvidas = baseUrlFunc() + "emailsugestao/v1/rout"

  constructor(public http: HttpInterceptorProvider, public userProvider: UserProvider) {
    console.log('Hello ReportsProvider Provider');
  }

  solicitarContato(forma_contato: string, data: string, hora: string, especialidade): Observable<any> {
    return Observable.create(observer => {

      let user = this.userProvider.getUserStoraged();

      let bodyObj = {};

      if (user != undefined) {
        bodyObj['nome'] = user.general.data.display_name
        bodyObj['email'] = user.general.data.user_email;
        bodyObj['telefone'] = user.acf.celular;
        bodyObj['crm'] = user.acf["crm-medico"];
        bodyObj['uf'] = user.acf.uf;
      }
      bodyObj['forma_contato'] = forma_contato;
      bodyObj['opcao_escolha'] = especialidade;
      bodyObj['data'] = data;
      bodyObj['hora'] = hora;

      this.http.postQS(this.apiBase, bodyObj).subscribe(data => {
        observer.next(data)
        console.log("register success response", data)
      }, err => {
        observer.error(err)
        console.log("register error response", err)
      })

    })
  }

  enviarDuvidasESugestoes(assunto: string, descricao: string, anexo: string): Observable<any> {
    return Observable.create(observer => {

      let user = this.userProvider.getUserStoraged();

      let bodyObj = {};

      if (user != undefined) {
        bodyObj['nome'] = user.general.data.display_name;
        bodyObj['email'] = user.general.data.user_login;
        bodyObj['telefone'] = user.acf["celular"];
        bodyObj['crm'] = user.acf["crm-medico"];
        bodyObj['uf'] = user.acf["uf"];
        bodyObj['assunto'] = assunto;
        bodyObj['mensagem'] = descricao;
        bodyObj['anexo'] = anexo;
      }

      this.http.postQS(this.apiBaseDuvidas, bodyObj).subscribe(data => {
        observer.next(data)
      }, err => {
        observer.next()
      })

    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/reports/reports.ts